define('home/views/ChannelFeedEmptyView',[
    'backbone-marionette',

    'home/models/Session',
    'home/templates/channelFeedEmpty',
    'home/templates/channelOwnerFeedEmpty',
], function (
    Marionette,

    Session,
    channelFeedEmptyTemplate,
    channelOwnerFeedEmptyTemplate
) {
    'use strict';

    var ChannelFeedEmptyView = Marionette.ItemView.extend({
        getTemplate: function () {
            if (this.model.get('owner_id') === this.session.user.get('id'))
                return channelOwnerFeedEmptyTemplate;

            return channelFeedEmptyTemplate;
        },

        initialize: function () {
            this.session = Session.get();
        },
    });

    return ChannelFeedEmptyView;
});

